module.exports = __webpack_public_path__ + "static/media/search-no-colleagues.46d4ea79.svg";